import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {map} from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CommonHelper } from '../helpers/common';

@Injectable({
  providedIn: 'root'
})
export class CouponsService {

  private url = environment.urlApiRest;
  private language: string = CommonHelper.requestLanguage;

  constructor( private http: HttpClient) {  

  }

  get(data : Object){
        
    let headers = new HttpHeaders({
      'Content-Type':'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}prepaid/coupon/code?is_lmp_live=1&lang=${this.language}`,data,{headers:headers}).pipe(
      map( resp => {
        return resp;
      })
    );
  }

  post(data : Object){
    let headers = new HttpHeaders({
      'Content-Type':'application/x-www-form-urlencoded'
    });

    return this.http.post(`${this.url}prepaid/coupon/implement?is_lmp_live=1&lang=${this.language}`,data,{headers:headers}).pipe(
      map( resp => {
        return resp;
      })
    );
  }


}
